import { Tag } from 'antd';
import clsx from 'classnames';
import React, { FC } from 'react';
import './index.scss';
import type { TagProps } from 'antd';

export const TdsTag: FC<TagProps> = (props) => {
  const { className, children, ...rest } = props;

  return (
    <Tag className={clsx('tds-tag', className)} {...rest}>
      {children}
    </Tag>
  );
};
